
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  name: 'AccountWalletDetailsLoader',
  components: { SkeletonLoader }
})
export default class AccountWalletDetailsLoader extends Vue {}
